import debounce from 'lodash.debounce'
import GoodsModel from '../goods'
import Pay from '../pay'
import Vas from '../value-added-service'

export default [{
  type: 'mul-shop', // 连锁版
  imgCover: require('../../assets/images/all-versions/mul-shop-bg.png'),
  descs: [{
    content: '多店统一管理后台'
  }, {
    content: '各门店灵活版本组合'
  }, {
    content: '商品多店调拨'
  }, {
    content: '会员信息共享'
  }, {
    content: '营销活动同步'
  }, {
    content: '支持50家连锁店管理'
  }],
  btn: {
    type: 'default',
    class: ['fullpage-btn', 'overwrite-btn'],
    title: '电脑端购买享更多优惠',
    func: debounce(function () {
    }, 220)
  }
}, {
  type: 'senior', // 高级版
  imgCover: require('../../assets/images/all-versions/senior-bg.png'),
  descs: [{
    content: '无限制商品/会员录入'
  }, {
    content: '会员积分等级&营销计划'
  }, {
    content: '20个店员专属账号'
  }, {
    content: '每月10,000张优惠券'
  }],
  descBtn: {
    title: '点击查看完整功能',
    func: function () {
      this.$router.push({name: 'vasDetail', params: {id: GoodsModel.saas.advanced.id}})
    }
  },
  btn: {
    title: '立即购买',
    class: 'fullpage-btn',
    func: debounce(function () {
      let id = GoodsModel.saas.advanced.id
      let vas = new Vas()
      vas.loadDetail(id).then((res, e) => {
        if (!vas.isCanBuy()) {
          this.$wejs.alert(vas.getErrorMess())
          return
        }
        new Pay().saasPay(id, 12)
      })
    }, 220)
  }
}, {
  type: 'food', // 餐饮版
  imgCover: require('../../assets/images/all-versions/food-bg.png'),
  descs: [{
    content: '包含高级版所有功能'
  }, {
    content: '支持台位管理、台位计时'
  }, {
    content: '台位二维码自助点单系统'
  }, {
    content: '后厨打印、加料管理'
  }],
  descBtn: {
    title: '点击查看完整功能',
    func: function () {
      this.$router.push({name: 'vasDetail', params: {id: GoodsModel.saas.food.id}})
    }
  },
  btn: {
    title: '立即购买',
    class: 'fullpage-btn',
    func: debounce(function () {
      let id = GoodsModel.saas.food.id
      let vas = new Vas()
      vas.loadDetail(id).then((res, e) => {
        if (!vas.isCanBuy()) {
          this.$wejs.alert(vas.getErrorMess())
          return
        }
        new Pay().saasPay(id, 12)
      })
    }, 220)
  }
}, {
  type: 'profession', // 行业版
  imgCover: require('../../assets/images/all-versions/profession-bg.png'),
  descs: [{
    content: '包含高级版所有功能'
  }, {
    content: '支持颜色&尺码录入'
  }, {
    content: '条码批量生成&打印'
  }, {
    content: '50个店员专属账号'
  }],
  descBtn: {
    title: '点击查看完整功能',
    func: function () {
      this.$router.push({name: 'vasDetail', params: {id: GoodsModel.saas.professionClothing.id}})
    }
  },
  btn: {
    title: '立即购买',
    class: 'fullpage-btn',
    func: debounce(function () {
      let id = GoodsModel.saas.professionClothing.id
      let quantity = GoodsModel.saas.professionClothing.quantity
      let vas = new Vas()
      vas.loadDetail(id).then((res, e) => {
        if (!vas.isCanBuy()) {
          this.$wejs.alert(vas.getErrorMess())
          return
        }
        new Pay().saasPay(id, quantity)
      })
    }, 220)
  }
}, {
  type: 'profession', // 行业版-丽人
  imgCover: require('../../assets/images/all-versions/liren.png'),
  descs: [{
    content: '包含高级版所有功能'
  }, {
    content: '支持会员预约'
  }, {
    content: '会员可拥有多张计次卡'
  }, {
    content: '50个员工专属账号'
  }, {
    content: '员工提成计算'
  }],
  descBtn: {
    title: '点击查看完整功能',
    func: function () {
      this.$router.push({name: 'vasDetail', params: {id: GoodsModel.saas.professionBarber.id}})
    }
  },
  btn: {
    title: '立即购买',
    class: 'fullpage-btn',
    func: debounce(function () {
      let id = GoodsModel.saas.professionBarber.id
      let quantity = GoodsModel.saas.professionBarber.quantity
      let vas = new Vas()
      vas.loadDetail(id).then((res, e) => {
        if (!vas.isCanBuy()) {
          this.$wejs.alert(vas.getErrorMess())
          return
        }
        new Pay().saasPay(id, quantity)
      })
    }, 220)
  }
}, {
  type: 'profession', // 行业版-手机数码
  imgCover: require('../../assets/images/all-versions/mobile.png'),
  descs: [{
    content: '包含高级版所有功能'
  }, {
    content: '支持串码录入'
  }, {
    content: 'A4&三联单打印'
  }, {
    content: '50个员工专属账号'
  }, {
    content: '员工提成计算'
  }],
  descBtn: {
    title: '点击查看完整功能',
    func: function () {
      this.$router.push({name: 'vasDetail', params: {id: GoodsModel.saas.profession3C.id}})
    }
  },
  btn: {
    title: '立即购买',
    class: 'fullpage-btn',
    func: debounce(function () {
      let id = GoodsModel.saas.profession3C.id
      let quantity = GoodsModel.saas.profession3C.quantity
      let vas = new Vas()
      vas.loadDetail(id).then((res, e) => {
        if (!vas.isCanBuy()) {
          this.$wejs.alert(vas.getErrorMess())
          return
        }
        new Pay().saasPay(id, quantity)
      })
    }, 220)
  }
}]



// WEBPACK FOOTER //
// ./src/model/all-version/index.js